import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';
import { get } from 'lodash';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { savePurchaseInformation, purchaseTickets, cancelTransaction } from '../../eventActions';

import { searchTeamsInCampaign } from '../../../../../search/searchActions';
import { fetchCampaign } from '../../../../../campaign/campaignActions';
import { fetchParticipantByMemberId } from '../../../../../participant/participantActions';
import { verifyTeamNames } from '../../../../../team/teamActions';

import TicketsDetailsForm from './TicketsDetailsForm';

const mapStateToProps = state => ({
  campaign: get(state, 'campaign.campaign'),
  event: get(state, 'Event.event'),
  team: get(state, 'team.team'),
  locale: get(state, 'session.language'),
  ticketSelection: get(state, 'Event.ticketSelection', null),
  teams: get(state, 'search.teams.results', []),
  user: get(state, 'session.user', null),
  userTypeId: get(state, 'session.userTypeId', 0),
  purchaseInformation: get(state, 'Event.purchaseInformation', null),
  surveyId: state.donation.surveyId,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchTeamsInCampaign,
  fetchCampaign,
  savePurchaseInformation,
  fetchParticipantByMemberId,
  purchaseTickets,
  cancelTransaction,
  verifyTeamNames
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withGoogleReCaptcha,
  Form.create()
)(TicketsDetailsForm);
